// products 
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_ERROR = "GET_PRODUCT_ERROR";
export const PRODUCT_CLEAN_UP = "PRODUCT_CLEAN_UP";
export const GET_FILTERED_PRODUCTS_SUCCESS = 'GET_FILTERED_PRODUCTS_SUCCESS';
export const GET_FILTERED_PRODUCTS_ERROR = 'GET_FILTERED_PRODUCTS_ERROR';
export const RESET_FILTERED_PRODUCTS = 'RESET_FILTERED_PRODUCTS';
export const RESET = "RESET";

// items 
export const GET_BRANDS_SUCCESS = 'GET_BRANDS_SUCCESS';
export const GET_BRANDS_ERROR = "GET_BRANDS_ERROR";
export const GET_MATERIALS_SUCCESS = "GET_MATERIALS_SUCCESS";
export const GET_MATERIALS_ERROR = "GET_MATERIALS_ERROR";
export const GET_PATTERNS_SUCCESS = "GET_PATTERNS_SUCCESS";
export const GET_PATTERNS_ERROR = "GET_PATTERNS_ERROR";
export const GET_COLORS_SUCCESS = "GET_COLORS_SUCCESS";
export const GET_COLORS_ERROR = "GET_COLORS_ERROR";
export const GET_ATTRIBUTES_SUCCESS = "GET_ATTRIBUTES_SUCCESS";
export const GET_ATTRIBUTES_ERROR = "GET_ATTRIBUTES_ERROR";
export const GET_STYLES_SUCCESS = "GET_STYLES_SUCCESS";
export const GET_STYLES_ERROR = "GET_STYLES_ERROR";
export const GET_MEASUREMENTS_SUCCESS = "GET_MEASUREMENTS_SUCCESS";
export const GET_MEASUREMENTS_ERROR = "GET_MEASUREMENTS_ERROR";
export const GET_BUY_SUCCESS = "GET_BUY_SUCCESS";
export const GET_BUY_ERROR = "GET_BUY_ERROR";
export const GET_BUY_START = "GET_BUY_START";
export const RESET_GET_BUY_SUCCESS = "RESET_GET_BUY_SUCCESS";
export const CREATE_BUY_SUCCESS = "CREATE_BUY_SUCCESS";
export const CREATE_BUY_ERROR = "CREATE_BUY_ERROR";
export const RESET_CREATE_BUY_SUCCESS = "RESET_CREATE_BUY_SUCCESS";
export const UPDATE_BUY_SUCCESS = "UPDATE_BUY_SUCCESS";
export const UPDATE_BUY_ERROR = "UPDATE_BUY_ERROR";
export const UPDATE_BUY_START = "UPDATE_BUY_START";
export const RESET_UPDATE_BUY_SUCCESS = "RESET_UPDATE_BUY_SUCCESS";
export const UPDATE_ITEM_SUCCESS = "UPDATE_ITEM_SUCCESS";
export const UPDATE_ITEM_ERROR = "UPDATE_ITEM_ERROR";
export const UPDATE_ITEM_START = "UPDATE_ITEM_START";
export const RESET_UPDATE_ITEM_SUCCESS = "RESET_UPDATE_ITEM_SUCCESS";
export const GET_ITEM_SUCCESS = "GET_ITEM_SUCCESS";
export const GET_ITEM_ERROR = "GET_ITEM_ERROR";
export const CREATE_ITEM_SUCCESS = "CREATE_ITEM_SUCCESS";
export const CREATE_ITEM_ERROR = "CREATE_ITEM_ERROR";
export const RESET_CREATE_ITEM_SUCCESS = "RESET_CREATE_ITEM_SUCCESS";
export const GET_QR_CODE_SUCCESS = "GET_QR_CODE_SUCCESS";
export const GET_QR_CODE_ERROR = "GET_QR_CODE_ERROR";
export const GET_QR_CODE_START = "GET_QR_CODE_START";

// customer
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_START = "LOGIN_START";
export const RESET_LOGIN_SUCCESS = "RESET_LOGIN_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const REGISTER_START = "REGISTER_START";
export const RESET_REGISTER_SUCCESS = "RESET_REGISTER_SUCCESS";
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = "GET_COUNTRIES_ERROR";
export const ADD_ENUM_SUCCESS = "ADD_ENUM_SUCCESS";
export const ADD_ENUM_ERROR = "ADD_ENUM_ERROR";
export const ADD_ENUM_START = "ADD_ENUM_START";
export const RESET_NEW_ENUM = "RESET_NEW_ENUM";
export const GET_LAST_OPEN_BUY_ID_SUCCESS = "GET_LAST_OPEN_BUY_ID_SUCCESS";
export const GET_LAST_OPEN_BUY_ID_ERROR = "GET_LAST_OPEN_BUY_ID_ERROR";
export const DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS";
export const DELETE_ITEM_ERROR = "DELETE_ITEM_ERROR";
export const DELETE_ITEM_START = "DELETE_ITEM_START";
export const RESET_DELETED_ITEM_ID = "RESET_DELETED_ITEM_ID";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_ERROR = "GET_CUSTOMER_ERROR";
export const RESET_GET_CUSTOMER_SUCCESS = "RESET_GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_START = "GET_CUSTOMER_START";
export const GET_TYPE_GROUPS_SUCCESS = "GET_TYPE_GROUPS_SUCCESS";
export const GET_TYPE_GROUPS_ERROR = "GET_TYPE_GROUPS_ERROR";
export const ADD_ITEM_PHOTOS_SUCCESS = "ADD_ITEM_PHOTOS_SUCCESS";
export const ADD_ITEM_PHOTOS_ERROR = "ADD_ITEM_PHOTOS_ERROR";
export const ADD_ITEM_PHOTOS_START = "ADD_ITEM_PHOTOS_START";
export const RESET_NEW_PHOTOS = "RESET_NEW_PHOTOS";
export const DELETE_PHOTO_SUCCESS = "DELETE_PHOTO_SUCCESS";
export const DELETE_PHOTO_ERROR = "DELETE_PHOTO_ERROR";
export const DELETE_PHOTO_START = "DELETE_PHOTO_START";
export const RESET_DELETED_PHOTO_ID = "RESET_DELETED_PHOTO_ID";
export const SUBMIT_BUY_SUCCESS = "SUBMIT_BUY_SUCCESS";
export const SUBMIT_BUY_ERROR = "SUBMIT_BUY_ERROR";
export const SUBMIT_BUY_START = "SUBMIT_BUY_START";
export const RESET_SUBMIT_BUY_SUCCESS = "RESET_SUBMIT_BUY_SUCCESS";
export const ADD_ADDRESS_SUCCESS = "ADD_ADDRESS_SUCCESS";
export const ADD_ADDRESS_ERROR = "ADD_ADDRESS_ERROR";
export const GET_UNSUBMITTED_ITEMS_SUCCESS = "GET_UNSUBMITTED_ITEMS_SUCCESS";
export const GET_UNSUBMITTED_ITEMS_ERROR = "GET_UNSUBMITTED_ITEMS_ERROR";
export const UPDATE_ADDRESS_SUCCESS = "UPDATE_ADDRESS_SUCCESS";
export const UPDATE_ADDRESS_ERROR = "UPDATE_ADDRESS_ERROR";
export const UPDATE_ADDRESS_START = "UPDATE_ADDRESS_START";
export const RESET_UPDATE_ADDRESS_SUCCESS = "RESET_UPDATE_ADDRESS_SUCCESS";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_ERROR = "UPDATE_CUSTOMER_ERROR";
export const RESET_UPDATE_CUSTOMER_SUCCESS = "RESET_UPDATE_CUSTOMER_SUCCESS";
export const HANDLE_OFFER_ERROR = "HANDLE_OFFER_ERROR";
export const HANDLE_OFFER_START = "HANDLE_OFFER_START";
export const HANDLE_OFFER_SUCCESS = "HANDLE_OFFER_SUCCESS";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const RESET_RESET_PASSWORD_SUCCESS = "RESET_RESET_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const RESET_CHANGE_PASSWORD_SUCCESS = "RESET_CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_START = "CHANGE_PASSWORD_START";
export const VERIFY_ACCOUNT_SUCCESS = "VERIFY_ACCOUNT_SUCCESS";
export const VERIFY_ACCOUNT_ERROR = "VERIFY_ACCOUNT_ERROR";
export const RESET_VERIFY_ACCOUNT_SUCCESS = "RESET_VERIFY_ACCOUNT_SUCCESS";
export const VERIFY_ACCOUNT_START = "VERIFY_ACCOUNT_START";


